import { E as EMPTY_VALUES } from './constants.js';

function checkNonEmpty(value, error) {
    if (EMPTY_VALUES.some(v => v === value)) {
        throw new Error(error);
    }
}

export { checkNonEmpty as c };
